// extracted by mini-css-extract-plugin
module.exports = {"qrCode_box":"qrCode_box-2FGq-djn","fix_qrCode_box":"fix_qrCode_box-Td6NgRXU","title":"title-1sBTYG9l","line":"line-k_t7Uuix","img_box":"img_box-1L9R_65M","tip":"tip-1Qhr8mx0"};